import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { LogicMelonForm } from '~/components/features/integrations/logicmelon/logicmelon-form';
import { PageContainer } from '~/components/layouts/page-container';
import { useDocumentTitle } from '~/hooks/use-document-title';
import { useSlugIds } from '~/hooks/use-slug-ids';
import { resolveOrgId } from '~/lib/slug-resolver';
import { atsConfigQueryOptions } from '~/queries/integrations.queries';

export const Route = createFileRoute('/_authenticated/org/$orgSlug/integrations/logicmelon/')({
  loader: ({ context, params }) => {
    const orgId = resolveOrgId(context.queryClient, params.orgSlug);
    if (orgId) {
      void context.queryClient.ensureQueryData(atsConfigQueryOptions(orgId));
    }
  },
  component: LogicMelonPage
});

function LogicMelonPage(): React.ReactNode {
  const { t } = useTranslation();
  useDocumentTitle(t('integrations.ats.providers.logicmelon'));
  const { orgSlug } = Route.useParams();
  const { orgId } = useSlugIds(orgSlug);
  const { data } = useQuery({ ...atsConfigQueryOptions(orgId), enabled: !!orgId });

  const config = data?.config?.provider === 'logicmelon' ? data.config : null;

  return (
    <PageContainer
      title="LogicMelon"
      subtitle={t('integrations.ats.description')}
      actions={
        <img
          src="/integrations/logicmelon.webp"
          alt="LogicMelon"
          className="w-24 h-12 rounded-2xl object-contain"
        />
      }
      breadcrumbs={[
        { label: t('integrations.title'), href: `/org/${orgSlug}/integrations` },
        { label: 'LogicMelon' }
      ]}
    >
      <LogicMelonForm orgId={orgId} config={config} />
    </PageContainer>
  );
}
